/* Mobile-Menü (Vollbild-Overlay) — Drill-down-Stack + DOM-Controller.
   Reine Stack-Funktionen sind unter Node testbar; der Controller (init)
   wird in einem späteren Schritt ergänzt. */
(function (root) {
  'use strict';

  // ---- reine Drill-down-Stack-Funktionen ----
  function resetStack(rootId) { return [rootId]; }
  function pushLevel(stack, id) { return stack.concat([id]); }
  function popLevel(stack) { return stack.length > 1 ? stack.slice(0, -1) : stack.slice(); }
  function currentLevel(stack) { return stack[stack.length - 1]; }

  // ---- DOM-Controller (nur Browser) ----
  function init(doc) {
    var drawer = doc.getElementById('t-mobile-drawer');
    if (!drawer) return;
    var sheet = drawer.querySelector('.t-mobile-drawer__sheet');
    var nav = drawer.querySelector('.t-mobile-drawer__nav');
    var hamburger = doc.querySelector('[data-action="open-mobile-drawer"]');
    var ROOT = 'root';
    var SLIDE_MS = 280;
    var stack = resetStack(ROOT);

    function lockScroll(on) {
      doc.body.style.overflow = on ? 'hidden' : '';
      if (on) doc.documentElement.setAttribute('data-overlay-open', 'true');
      else doc.documentElement.removeAttribute('data-overlay-open');
    }
    function panelById(id) { return nav.querySelector('[data-panel="' + id + '"]'); }

    function resetPanels() {
      stack = resetStack(ROOT);
      var panels = nav.querySelectorAll('.t-mobile-drawer__panel');
      Array.prototype.forEach.call(panels, function (p) {
        var isRoot = p.getAttribute('data-panel') === ROOT;
        p.hidden = !isRoot;
        p.classList.remove('is-prev', 'is-next');
        p.classList.toggle('is-current', isRoot);
      });
      nav.scrollTop = 0;
    }

    function slide(toId, dir) {
      var from = nav.querySelector('.t-mobile-drawer__panel.is-current');
      var to = panelById(toId);
      if (!to || to === from) return;
      to.hidden = false;
      to.classList.add(dir === 'forward' ? 'is-next' : 'is-prev');
      void to.offsetWidth; // reflow erzwingen, damit die Transition greift
      to.classList.remove('is-next', 'is-prev');
      to.classList.add('is-current');
      from.classList.remove('is-current');
      from.classList.add(dir === 'forward' ? 'is-prev' : 'is-next');
      to.scrollTop = 0;
      root.setTimeout(function () {
        from.classList.remove('is-prev', 'is-next');
        from.hidden = true;
      }, SLIDE_MS);
    }

    function drillTo(id) { stack = pushLevel(stack, id); slide(id, 'forward'); }
    function drillBack() {
      if (stack.length <= 1) return;
      stack = popLevel(stack);
      slide(currentLevel(stack), 'back');
    }

    function trapFocus(e) {
      var f = sheet.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
      if (!vis.length) return;
      var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function openDrawer() {
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      resetPanels();
      var closeBtn = sheet.querySelector('.t-mobile-drawer__close');
      if (closeBtn) root.setTimeout(function () { closeBtn.focus(); }, 50);
      if (root.history && root.history.pushState) root.history.pushState({ tDrawer: true }, '');
    }
    function closeDrawer(opts) {
      opts = opts || {};
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      if (!opts.keepScrollLock) lockScroll(false);
      if (hamburger) {
        hamburger.setAttribute('aria-expanded', 'false');
        if (!opts.noFocus) hamburger.focus();
      }
      if (!opts.fromPop && root.history && root.history.state && root.history.state.tDrawer) {
        root.history.back();
      }
    }

    Array.prototype.forEach.call(doc.querySelectorAll('[data-action="open-mobile-drawer"]'), function (el) {
      el.addEventListener('click', openDrawer);
    });
    Array.prototype.forEach.call(doc.querySelectorAll('[data-action="close-mobile-drawer"]'), function (el) {
      el.addEventListener('click', function () { closeDrawer(); });
    });

    nav.addEventListener('click', function (e) {
      var drill = e.target.closest('[data-drill]');
      if (drill) { e.preventDefault(); drillTo(drill.getAttribute('data-drill')); return; }
      if (e.target.closest('[data-drill-back]')) { e.preventDefault(); drillBack(); }
    });

    // Such-Übergabe: Menü schließen, aber Scroll-Lock NICHT lösen — das
    // Such-Overlay (data-action="open-search") hält den Lock selbst.
    var searchBtn = drawer.querySelector('[data-drawer-search]');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        closeDrawer({ keepScrollLock: true, noFocus: true });
      });
    }

    doc.addEventListener('keydown', function (e) {
      if (drawer.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') closeDrawer();
      else if (e.key === 'Tab') trapFocus(e);
    });
    root.addEventListener('popstate', function () {
      if (drawer.getAttribute('data-open') === 'true') closeDrawer({ fromPop: true });
    });
  }

  var api = {
    resetStack: resetStack,
    pushLevel: pushLevel,
    popLevel: popLevel,
    currentLevel: currentLevel,
    init: init
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.TrautisMobileDrawer = api;
    if (root.document) {
      if (root.document.readyState !== 'loading') init(root.document);
      else root.document.addEventListener('DOMContentLoaded', function () { init(root.document); });
    }
  }
})(typeof window !== 'undefined' ? window : this);
